import { createAction } from 'redux-actions';
import { get, post, put, del } from 'redux/shelf/api';
import { field } from 'redux/shelf';

export default {
  signIn: post`/accounts/login`(),
  register: post`/accounts/generic`(),
  signOut: createAction('signOut'),
  kcSignOut: del`/keycloak/me`(),
  setMerchantId: createAction('setMerchantId'),
  setOnboardingId: createAction('setOnboardingId'),
  setPassword: post`/accounts/set-password`(field('data')),
  resetPassword: post`/accounts/reset-password`(),
  forgotPassword: post`/accounts/forgot-password`(),
  getUser: get`/merchants`(field('data')),
  startKeycloakLogin: get`/keycloak/login/1`(),
  getMerchant: get`/merchants/:id`(field('merchant')),
  validateCC: get`/merchants/:id/payments/processor/is-cc-expired`(),
  getShopifyThemes: get`/merchants/:id/shopify/themes`(field('themes')),
  integrateShopify: post`/merchants/:id/shopify/tag`(),
  checkShopifyOnlineStore2Support:
    get`/merchants/:id/shopify/:themeId/online-store-2-support`(),
  updateMerchantPlatform: put`/merchants/:id/platform-info`(),
};
